import React, { FunctionComponent } from "react";
import { blue } from "designSystem/styles/color";
import FlexRowCenter from "../flex/FlexRowCenter";
import { useLocale } from "designSystem/locale";
import ThreeDots from "../progress/ThreeDots";
import Placeholder from "./Placeholder";
import { TextProps } from "../text/Text";

interface LoadingPlaceholderProps {
	/** type of node being loaded */
	type?: string;

	/** title text properties */
	titleProps?: Omit<TextProps, "size">;

	/** subtitle text properties */
	subtitleProps?: Omit<TextProps, "size">;
}

const LoadingPlaceholder: FunctionComponent<LoadingPlaceholderProps> = (props) => {
	const { type, titleProps, subtitleProps } = props;
	const loc = useLocale();
	const resParams = [loc.type(type, true)
		?.toLocaleLowerCase()];

	return (
		<Placeholder
			subtitleProps={subtitleProps ?? { res: "LoadingInProgress", resParams }}
			titleProps={titleProps ?? { res: "LoadingPattern", resParams }}
		>
			{{
				image:
					<FlexRowCenter height={72} justifyContent="center">
						<ThreeDots color={blue[200]} />
					</FlexRowCenter>,
			}}
		</Placeholder>
	);
};

export default LoadingPlaceholder;